<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">房间号：</span>
        </div>
        <el-select v-model="formData.roomCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入房间号查询">
          <el-option v-for="item in roomList" :key="item.code"
                     :label="item.roomNumber" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">经纪人：</span>
        </div>
        <el-select v-model="formData.personCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="getPersonListRemoteMethod"
                   placeholder="请输入姓名/手机号/住户名称查询">
          <el-option v-for="item in agentPersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">看房时间：</span>
        </div>
        <el-date-picker
          v-model="formData.showRoomTime"
          type="datetime"
          size="small"
          style="width: 280px"
          :editable=false
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期">
        </el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">看房结果：</span>
        </div>
        <el-input v-model="formData.showRoomResults" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top">
          <span class="line-text">备注：</span>
        </div>
        <el-input type="textarea" :rows="3" v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/agent'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import UploadImgList from '../../../components/Input/UploadImgList'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'repair-category-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧经纪',
          name: 'investment-manage'
        }, {
          value: '看房记录'
        }],
        mainTitle: '添加看房记录',
        subheading: '',

        roomList: [],
        agentPersonList: [],
        formData: {
          roomCode: '',
          personCode: '',
          personName: '',
          operatePersonCode: '',
          operatePersonName: '',
          showRoomResults: '',
          showRoomTime: '',
          memo: '',
        },

      }
    },
    created () {
      this.formData.operatePersonCode = bus.global.accountCode
      this.formData.operatePersonName = bus.global.accountName
      this.remoteMethod()
      this.getPersonListRemoteMethod()
    },
    methods: {
      toManagePage () {
        this.$router.push({
          name: 'agent-showing'
        })
      },

      remoteMethod (query) {
        this.getRoomList(query)
      },
      // 获取房间列表
      getRoomList (searchKey) {
        this.$axios.post(api.getAgentRoomList, {
          searchKey: searchKey || ''
        })
          .then(res => {
            let list = res.data.data
            this.roomList = list
          })
          .catch(errorHandler('获取房间列表失败'))
      },

      getPersonListRemoteMethod (query) {
        this.getAgentPersonList(query)
      },
      // 获取经纪人列表
      getAgentPersonList (searchKey) {
        this.$axios.post(api.getAgentPersonList, {
          searchKey: searchKey || ''
        })
          .then(res => {
            let list = res.data.data
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
            })
            this.agentPersonList = list
          })
          .catch(errorHandler('获取经纪人列表失败'))
      },
      confirm () {
        if (!this.formData.roomCode) {
          nError('请选择房间')
          return false
        }
        if (!this.formData.personCode) {
          nError('请选择经纪人')
          return false
        }
        if (!this.formData.showRoomTime) {
          nError('请选择看房时间')
          return false
        }
        if (!this.formData.showRoomResults) {
          nError('请输入看房结果')
          return false
        }
        this.agentPersonList.map(v => {
          if (v.code === this.formData.personCode) {
            this.formData.personName = v.name
          }
        })
        this.$axios.post(api.addRoomRecord, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toManagePage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/Agent/agentShowing/agentShowingAdd.vue